import request from '@/utils/request'
export function navList(params) {
    return request({
        url: 'business/menu/getTabMenuList',
        method: 'get',
        params
    })
}
